import { render, staticRenderFns } from "./AssignRoleDialog.vue?vue&type=template&id=9ed1b094"
import script from "./AssignRoleDialog.vue?vue&type=script&lang=js"
export * from "./AssignRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignRoleDialog.vue?vue&type=style&index=0&id=9ed1b094&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports